import React from "react"
import { browserHistory } from "react-router"
import AppStateStore from "../../stores/AppStateStore"
import TimecardPunchControl from "./TimecardPunchControl"
import AuthenticationStore from "../../stores/AuthenticationStore"
import AccountStore from "../../stores/AccountStore"
import strings from '../../localization/strings';
import moment from "moment"
import * as permissionHelper from "../../helpers/permissionHelper"
import {
    ITimecardDay, IPunchSetDocument, ITimecardEmployee, ISuspensePunchData, IJobStatusData, EJobStatusType,
    ICommentData, EPunchSetApprovalType
} from "../../models"
import TimeoffIcon from "material-ui/svg-icons/action/flight-takeoff"
import MobileBreakIcon from "material-ui/svg-icons/places/free-breakfast"
import autobind from "class-autobind"
import PunchDetailsDialog from "../punch/PunchDetailsDialog"
import PunchSetQuestionPreventExceptionDetailDialog from "../punch/punch_question_answer_detail/PunchSetQuestionPreventExceptionDetailDialog"
import { red500, grey50 } from "material-ui/styles/colors"
import * as timeHelper from "../../helpers/timeHelper"
import * as timecardHelper from "../../helpers/timecardHelper"
import TimecardSuspensePunchChip from "./TimecardSuspensePunchChip"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import * as userHelper from "../../helpers/userHelper"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
import ClientLocalDateTimeStr from "../common/ClientLocalDateTimeStr"
import ApproveIcon from "../approve/ApproveIcon"
import EmployeeTimecardTablePSCellChildren from "./EmployeeTimecardTablePSCellChildren"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"

interface IProps {
    day: ITimecardDay
    timecardLocked: boolean
    readonly: boolean
    punchSet: IPunchSetDocument
    childPunchSets: IPunchSetDocument[]
    user: ITimecardEmployee
    fullPunchSets: IPunchSetDocument[]
    suspensePunchData?: ISuspensePunchData
    jobStatusData?: IJobStatusData[]
    commentData?: ICommentData[]
    addPunch(timecardDay: ITimecardDay, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, shiftId: string, breakId: string, mobileBreakId: string, jobId: string, phaseId: string, equipmentId: string, isPunchIn: boolean, pairedPunchId: string): void
    onConfirmDelete(punchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    reloadTimecard(msg: string): void
    handleApprovePunchSet?(status: "unapprove" | "approve", punchSet: IPunchSetDocument): void

    //we need to select hierarchy based on employee punch permission, not logged in user punch permission (when the user has more punch rights than the admin)
    //it's possible when full timecard, for example, employee->timecard and payroll->timecard
    //timecards page is not full timecard in the case filter by punch level
    isFullTimecard?: boolean
    allowPriorPeriodAdjust?: boolean

    virtualTimecard?: boolean

    priorPeriodAdjustMode?: boolean
    originalTimecard?: boolean

    showTimecardDetails: boolean
}
interface IState {
    punchIdForDetailDialog: string
    preQuestFailedPunchSet: IPunchSetDocument
}

export default class EmployeeTimecardTablePSCell extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            punchIdForDetailDialog: null,
            preQuestFailedPunchSet: null,
        }
        autobind(this)
    }

    getBreakDurationString(breakObj) {
        //Positive minute values take away from the duration. Negative add.
        if (breakObj.BreakDurationInMinutes > 0) {
            return "- " + breakObj.BreakDurationInMinutes + "m"
        } else {
            return "+ " + breakObj.BreakDurationInMinutes + "m"
        }
    }

    render() {
        if (!userHelper.checkLoggedInUserPermission(this.props.user)) return null
        const actualPunchInTime = timeHelper.keepConvertUTCToLocal(this.props.punchSet.PunchInTimeLocal)
        let punchInTime = this.props.punchSet.RoundingRuleId ?
            timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundedPunchInTimeLocal) :
            actualPunchInTime
        const actualPunchOutTime = timeHelper.keepConvertUTCToLocal(this.props.punchSet.PunchOutTimeLocal)
        let punchOutTime = this.props.punchSet.RoundingRuleId ?
            timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundedPunchOutTimeLocal) :
            actualPunchOutTime

        const subPunchSetTextStyle = { fontSize: "9pt", marginTop: -5, float: "left", cursor: "pointer", color: this.props.punchSet.Calculated ? "#aaaaaa" : null }

        const punchInSuspenseReason = this.props.virtualTimecard && this.props.punchSet.PunchInId && timecardHelper.getSuspenseReasonsFromPunches([this.props.punchSet.PunchInId], this.props.suspensePunchData)
        const punchOutSuspenseReason = this.props.virtualTimecard && this.props.punchSet.PunchOutId && timecardHelper.getSuspenseReasonsFromPunches([this.props.punchSet.PunchOutId], this.props.suspensePunchData)
        const punchInSuspense = punchInSuspenseReason && punchInSuspenseReason.length > 0
        const punchOutSuspense = punchOutSuspenseReason && punchOutSuspenseReason.length > 0
        if (punchInSuspense) {
            const punchInSuspenseUpdate = this.props.suspensePunchData.ReviewSuspenseUpdateTimeData.find(i => i.Id === this.props.punchSet.PunchInId)
            if (punchInSuspenseUpdate) {
                punchInTime = timeHelper.keepConvertUTCToLocal(punchInSuspenseUpdate.DateTimeLocal)
            }
        }
        if (punchOutSuspense) {
            const punchOutSuspenseUpdate = this.props.suspensePunchData.ReviewSuspenseUpdateTimeData.find(i => i.Id === this.props.punchSet.PunchOutId)
            if (punchOutSuspenseUpdate) {
                punchOutTime = timeHelper.keepConvertUTCToLocal(punchOutSuspenseUpdate.DateTimeLocal)
            }
        }

        let jobRemovedOrInactivated = false
        if (this.props.punchSet.JobName && this.props.jobStatusData) {

            const jobStatus = this.props.jobStatusData.find(i => i.Id === this.props.punchSet.JobId)
            if (jobStatus) {
                jobRemovedOrInactivated = jobStatus.JobStatusType !== EJobStatusType.Activated
            }
        }

        const punchInComment = this.props.commentData && this.props.commentData.find(i => i.Id === this.props.punchSet.PunchInId)
        const punchOutComment = this.props.commentData && this.props.commentData.find(i => i.Id === this.props.punchSet.PunchOutId)
        const showSupervisorApproveIcon = !this.props.priorPeriodAdjustMode &&
            !punchInSuspense &&
            !punchOutSuspense &&
            !this.props.punchSet.Calculated &&
            !this.props.punchSet.HolidayName &&
            !this.props.punchSet.TimeOffRequestId


        return (
            <div>
                {this.props.punchSet.PreQuestionGUIds && this.props.punchSet.PreQuestionGUIds.length > 0 ?
                    <div style={{ height: 22, padding: "13px 0px" }}>
                        <div
                            style={{ cursor: "pointer", backgroundColor: red500, height: "100%", fontSize: 12, color: grey50, borderRadius: 11, textAlign: "center", position: "relative" }}
                            onClick={() => this.setState({ preQuestFailedPunchSet: this.props.punchSet })}
                        >
                            <div>
                                <i
                                    className="fa fa-exclamation-circle"
                                    style={{ position: "absolute", top: 4, left: 5, fontSize: 14, color: grey50 }}
                                />
                                <span style={{ marginLeft: 10 }}>
                                    {moment(timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundingRuleId ? this.props.punchSet.RoundedPunchInTimeLocal : this.props.punchSet.PunchInTimeLocal)).format("hh:mm a")}
                                </span>
                            </div>
                            <i
                                data-intercom-target={"menu-Employees-Timecards-Btn-Remove-PunchQuestionFailure"}
                                className="fa fa-remove ShowHover"
                                onClick={e => {
                                    e.stopPropagation()
                                    this.props.onConfirmDelete(this.props.punchSet.PunchInId ? this.props.punchSet.PunchInId : this.props.punchSet.PunchOutId)
                                }}
                                style={{ position: "absolute", top: 5, right: 5, color: grey50, cursor: "pointer" }}
                            />
                        </div>
                    </div> :
                    <div>
                        <div style={{ display: "flex", alignItems: "center", paddingLeft: showSupervisorApproveIcon ? 0 : 20 }}>
                            {showSupervisorApproveIcon &&
                                <div style={{ marginRight: 5, height: 16 }}>
                                    <ApproveIcon
                                        approvalType={EPunchSetApprovalType.Supervisor}
                                        toolTipPosition="bottom"
                                        toolTipArrow="center"
                                        identify={`supervisorapprove${this.props.punchSet.Id}`}
                                        width={15}
                                        punchSets={[this.props.punchSet]}
                                        expenses={[]}
                                        handleApproveStatus={
                                            permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ApproveTimecards) &&
                                                this.props.handleApprovePunchSet ?
                                                status => this.props.handleApprovePunchSet(status, this.props.punchSet) : null}
                                        locked={this.props.timecardLocked}
                                    />
                                </div>
                            }
                            <div style={{ display: "flex", flexDirection: AppStateStore.isLaptop() ? "column" : "row" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {AppStateStore.isLaptop() && <div style={{ fontSize: "7pt", marginRight: 5, width: 15, minWidth: 15 }}>IN</div>}
                                    {punchInSuspense ?
                                        <TimecardSuspensePunchChip
                                            keyStr={`${this.props.punchSet.PunchInId}`}
                                            suspenseReason={punchInSuspenseReason[0]}
                                            value={punchInTime}
                                            punchId={this.props.punchSet.PunchInId}
                                            readonly={this.props.timecardLocked || this.props.readonly}
                                            reloadTimecard={this.props.reloadTimecard}
                                        /> :
                                        <TimecardPunchControl
                                            key={"in" + this.props.punchSet.Id}
                                            punchSet={this.props.punchSet}
                                            hintText="IN"
                                            systemModified={this.props.punchSet.InTimeSystemAddedUpdated}
                                            modified={this.props.punchSet.InTimeManuallyAddedUpdated}
                                            timeChanged={this.props.punchSet.InTimeChanged}
                                            value={punchInTime}
                                            actualValue={actualPunchInTime}
                                            onRemovePunch={() => this.props.onConfirmDelete(this.props.punchSet.PunchInId)}
                                            punchId={this.props.punchSet.PunchInId}
                                            handleUpdatePunchTime={this.props.onTimeChange}
                                            readonly={this.props.timecardLocked || this.props.readonly}
                                            handleOpenPunchDetailDialog={() => this.setState({ punchIdForDetailDialog: this.props.punchSet.PunchInId })}
                                            timeFraud={this.props.punchSet.InTimeFraud}
                                        />
                                    }
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {AppStateStore.isLaptop() && <div style={{ fontSize: "7pt", marginRight: 5, width: 15, minWidth: 15 }}>OUT</div>}
                                    {punchOutSuspense ?
                                        <TimecardSuspensePunchChip
                                            keyStr={`${this.props.punchSet.PunchOutId}`}
                                            suspenseReason={punchOutSuspenseReason[0]}
                                            value={punchOutTime}
                                            punchId={this.props.punchSet.PunchOutId}
                                            readonly={this.props.timecardLocked || this.props.readonly}
                                            reloadTimecard={this.props.reloadTimecard}
                                        /> :
                                        <TimecardPunchControl
                                            key={"out" + this.props.punchSet.Id}
                                            punchSet={this.props.punchSet}
                                            hintText="+ OUT"
                                            systemModified={this.props.punchSet.OutTimeSystemAddedUpdated}
                                            modified={this.props.punchSet.OutTimeManuallyAddedUpdated}
                                            timeChanged={this.props.punchSet.OutTimeChanged}
                                            value={punchOutTime}
                                            actualValue={actualPunchOutTime}
                                            onAddPunch={() => this.props.addPunch(this.props.day, this.props.punchSet.HierarchyItemId, this.props.punchSet.PositionId, this.props.punchSet.PayClassId, this.props.punchSet.PayTypeId, this.props.punchSet.ShiftId, this.props.punchSet.BreakId, this.props.punchSet.MobileBreakId, this.props.punchSet.JobId, this.props.punchSet.PhaseId, this.props.punchSet.EquipmentId, false, this.props.punchSet.PunchInId)}
                                            onRemovePunch={() => this.props.onConfirmDelete(this.props.punchSet.PunchOutId)}
                                            punchId={this.props.punchSet.PunchOutId}
                                            handleUpdatePunchTime={this.props.onTimeChange}
                                            readonly={this.props.timecardLocked || this.props.readonly}
                                            missingPunch={!this.props.punchSet.PunchOutId}
                                            handleOpenPunchDetailDialog={() => this.setState({ punchIdForDetailDialog: this.props.punchSet.PunchOutId })}
                                            timeFraud={this.props.punchSet.OutTimeFraud}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        <div style={{ marginLeft: 20, position: "relative" }}>
                            {this.props.punchSet && this.props.showTimecardDetails &&
                                (this.props.punchSet.PunchInId && this.props.punchSet.IVRPunchIn) &&
                                (!this.props.punchSet.PunchOutId || this.props.punchSet.IVRPunchOut) &&
                                <i className="fa-light fa-phone-plus" style={{ fontSize: "9pt", fontWeight: 900, position: "absolute", left: -16 }} />
                            }
                            {this.props.punchSet && this.props.showTimecardDetails && !this.props.punchSet.Calculated &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <b>{strings.Pay_Type}: </b>
                                        {(() => {
                                            if (!this.props.punchSet.PayTypeId)
                                                return strings.Empty_PayType
                                            const payType = payGroupAndTypeHelper.getPayTypeById(this.props.punchSet.PayTypeId)
                                            return payType ? payType.Name : strings.Invalid_PayType
                                        })()}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.EquipmentId && this.props.showTimecardDetails &&
                                <div
                                    style={subPunchSetTextStyle}
                                    onClick={() => {
                                        permissionHelper.getLoggedInUserType() !== AuthenticationStore.LoggedInUserTypes.Employee &&
                                            permissionHelper.hasPermission(AuthenticationStore.Permissions.Equipment.ViewEquipment) &&
                                            browserHistory.push("/equipment-details/" + this.props.punchSet.EquipmentId + "/timecards")
                                    }}
                                >
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-wrench" />&nbsp;
                                        {this.props.punchSet.EquipmentName && this.props.punchSet.EquipmentName.toUpperCase()}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.AutoBreaks && this.props.punchSet.AutoBreaks.length > 0 && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    {this.props.punchSet.AutoBreaks.map((autoBreak, autoBreakIndex) =>
                                        <div key={autoBreakIndex} style={{ marginRight: 5 }}>
                                            <i className="fa fa-check" />&nbsp;
                                            {(autoBreak.BreakName ? autoBreak.BreakName.toUpperCase() : "Auto Break") + ": " + this.getBreakDurationString(autoBreak)}
                                        </div>
                                    )}
                                </div>
                            }
                            {this.props.punchSet.JobName && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5, color: jobRemovedOrInactivated && red500 }}>
                                        <b>{checkJobFieldAvailable('singular') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel : strings.Job.toUpperCase()}:</b> {this.props.punchSet.JobName}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.PhaseName && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <b>{checkPhaseFieldAvailable("singular") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel : strings.Phase.toUpperCase()}:</b> {this.props.punchSet.PhaseName}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.PositionName && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <b>{checkPositionFieldAvailable('singular') ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel : strings.Position}:</b> {this.props.punchSet.PositionName}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.HolidayName && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-gift" style={{ fontSize: 11 }} />&nbsp;
                                        {strings.Holiday}
                                    </div>
                                </div>
                            }
                            {!this.props.punchSet.PaidTime && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-money" />&nbsp;
                                        {strings.Unpaid}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.Calculated && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-calculator" />&nbsp;
                                        {this.props.punchSet.CalculatedLabel}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.TimeOffRequestId && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <TimeoffIcon style={{ color: "#aaaaaa", width: 12, height: 12 }} />&nbsp;
                                        {strings.Time_off}
                                    </div>
                                </div>
                            }
                            {!this.props.punchSet.CountsTowardsOvertime && this.props.showTimecardDetails && !this.props.punchSet.Calculated &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-hourglass-o" />&nbsp;
                                        {strings.No_Overtime}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.ShiftId && !this.props.punchSet.BreakId && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-calendar" />&nbsp;
                                        {strings.Shift}:&nbsp;
                                        <ClientLocalDateTimeStr
                                            hierarchyId={this.props.punchSet.HierarchyItemId}
                                            jobId={this.props.punchSet.JobId}
                                            utcTime={this.props.punchSet.ScheduleInfo.ShiftStartDateTime}
                                            formatStr="h:mma"
                                        />&nbsp;-&nbsp;
                                        <ClientLocalDateTimeStr
                                            hierarchyId={this.props.punchSet.HierarchyItemId}
                                            jobId={this.props.punchSet.JobId}
                                            utcTime={this.props.punchSet.ScheduleInfo.ShiftEndDateTime}
                                            formatStr="h:mma"
                                        />
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.BreakId && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <i className="fa fa-coffee" />&nbsp;
                                        {`${strings.Break_Duration}: ${this.props.punchSet.ScheduleInfo.BreakRecommendedDuration}`}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.OverrideDayGroupingTime && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        {strings.PUNCH_IN_DATE}: {moment(timeHelper.keepConvertUTCToLocal(this.props.punchSet.RoundingRuleId ? this.props.punchSet.RoundedPunchInTimeLocal : this.props.punchSet.PunchInTimeLocal)).format("MM-DD-YYYY")}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet.MobileBreakId && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <MobileBreakIcon style={{ color: "#aaaaaa", width: 10, height: 10 }} />&nbsp;
                                        {this.props.punchSet.MobileBreakName}
                                    </div>
                                </div>
                            }
                            {this.props.punchSet && this.props.punchSet.OverTimeDurationInMinutes > 0 && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div style={{ marginRight: 5 }}>
                                        <b>Reg:</b> {timeHelper.convertMinutesToHourStr(this.props.punchSet.RegularTimeDurationInMinutes)} <b>OT:</b> {timeHelper.convertMinutesToHourStr(this.props.punchSet.OverTimeDurationInMinutes)} {!AccountStore.getHideOT2() && <span><b>OT2:</b> {timeHelper.convertMinutesToHourStr(this.props.punchSet.DoubleOverTimeDurationInMinutes)}</span>}
                                    </div>
                                </div>
                            }
                            {punchInComment && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div
                                        style={{ marginRight: 5 }}
                                        title={punchInComment.Comment}
                                    >
                                        <i className="fa fa-pencil" />&nbsp;
                                        {punchInComment.Comment}
                                    </div>
                                </div>
                            }
                            {punchOutComment && this.props.showTimecardDetails &&
                                <div style={subPunchSetTextStyle}>
                                    <div
                                        style={{ marginRight: 5 }}
                                        title={punchOutComment.Comment}
                                    >
                                        <i className="fa fa-pencil" />&nbsp;
                                        {punchOutComment.Comment}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }

                <div style={{ clear: "both" }} />

                {this.props.childPunchSets &&
                    <EmployeeTimecardTablePSCellChildren
                        key={this.props.childPunchSets.length}
                        childPunchSets={this.props.childPunchSets}
                        timecardDay={this.props.day}
                        user={this.props.user}
                        fullPunchSets={this.props.fullPunchSets}
                        showTimecardDetails={this.props.showTimecardDetails}
                    />
                }

                {this.state.punchIdForDetailDialog &&
                    <PunchDetailsDialog
                        onRequestClose={() => this.setState({ punchIdForDetailDialog: null })}
                        punchId={this.state.punchIdForDetailDialog}
                        punchSet={this.props.punchSet}
                        reloadTimecard={this.props.reloadTimecard}
                        readonly={this.props.timecardLocked || this.props.readonly || (this.props.punchSet && (this.props.punchSet.TimeOffRequestId !== null || this.props.punchSet.HolidayName !== null))}
                        isFullTimecard={this.props.isFullTimecard}
                        employee={this.props.user}
                        onRemovePunch={() => {
                            this.props.onConfirmDelete(this.state.punchIdForDetailDialog)
                            this.setState({ punchIdForDetailDialog: null })
                        }}
                        allowPriorPeriodAdjust={this.props.allowPriorPeriodAdjust}
                        originalTimecard={this.props.originalTimecard}
                    />
                }
                {this.state.preQuestFailedPunchSet &&
                    <PunchSetQuestionPreventExceptionDetailDialog
                        punchSet={this.state.preQuestFailedPunchSet}
                        user={this.props.user}
                        handleClose={() => this.setState({ preQuestFailedPunchSet: null })}
                    />
                }
            </div>
        )
    }
}
